<template>
    <div>
        <v-row>
            <v-col cols="12" md="4" class="d-flex">
                <h4 class="text--gray parametros__sistema__h4">
                    Ação Reenviar contrato via WhatsApp com mensagem personalizada
                </h4>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="10" style="display: inline-flex">
                <v-radio-group v-model="Options.WhatsappPersonalizado" row style="margin-top: 7px; margin-right: -20px; padding-top: 0">
                    <v-radio label="Desabilitar" :value="0"></v-radio>
                    <v-radio label="Habilitar" :value="1"></v-radio>
                    <v-radio label="Habilitar para:" :value="2"></v-radio>
                </v-radio-group>
                <div class="div--comboBox" :style="{ 'margin-bottom': isEnabled.WhatsappPersonalizado ? '-26px !important' : '' }">
                    <DynamicSelect v-if="dadosCarregados" placeholder="Selecione os pontos de venda" v-model="pvsSelecionados.WhatsappPersonalizado" endpoint="/dynamic-selects/pontos_venda/selecionados" :class="{ isDisabled: !isEnabled.WhatsappPersonalizado, comboBoxEnorme: true }" :disabled="!isEnabled.WhatsappPersonalizado"
                                   confirm-on-clear />
                </div>
            </v-col>
        </v-row>
    </div>
</template>

<script>
  import { AlertTypes } from '@/plugins/alerts_types'
  import { ValuesFunctionalities } from '@/plugins/constants'
  import { notification, sleep } from '@/plugins/helpers'
  export default {
    name: 'ConfiguracoesPorPv',
    props: {
      shouldSaveRestricoesPvs: {
        type: Boolean,
        default: false
      }
    },
    data: () => ({
      Options: {
        WhatsappPersonalizado: 0
      },
      OptionsEach: ['WhatsappPersonalizado'],
      pvsSelecionados: {
        WhatsappPersonalizado: []
      },
      NomeFuncionalidade: {
        WhatsappPersonalizado: 'WhatsappPersonalizado'
      },
      NomeColunas: {
        WhatsappPersonalizado: 'whatsapp_personalizado'
      },
      isEnabled: {
        WhatsappPersonalizado: false
      },
      dadosCarregados: false
    }),
    watch: {
      'Options.WhatsappPersonalizado' (newValue) {
        this.isEnabled.WhatsappPersonalizado = newValue === 2
      }
    },
    mounted () {
      this.SetarDadosFuncionalidadesPvs([])
    },
    methods: {
      async SetarDadosFuncionalidadesPvs () {
        try {
          const response = await this.$http.post('/painel/configuracao/restricoes_pontos_venda/get', { nome_colunas: this.NomeColunas })
          let data = response.data.restricoes
          data.forEach(dado => {
            this.Options[dado.funcionalidade] = dado.config
            this.pvsSelecionados[dado.funcionalidade] = JSON.parse(dado.pontos_venda)
          })
          await sleep(100) // Agora sim, aguarda 100ms!
          this.dadosCarregados = true
        } catch (error) {
          notification(AlertTypes.ERROR, `${error.response?.data?.error || error.message}`)
        }
      },
      limparCampos () {
        let options = Object.keys(this.Options)
        options.forEach(option => {
          if (this.Options[option] !== ValuesFunctionalities.HABILITAR_PARA && this.pvsSelecionados[option] && this.pvsSelecionados[option].length > 0) {
            this.pvsSelecionados[option] = []
          }
        })
      },
      async salvarRestricoesPvs () {
        if (this.Options.WhatsappPersonalizado === ValuesFunctionalities.HABILITAR_PARA && this.pvsSelecionados.WhatsappPersonalizado.length === 0) {
          notification(AlertTypes.WARN, 'Necessário informar ao menos 1 ponto de venda para acesso das funcionalidades listadas.')
          return
        }
        this.limparCampos()
        try {
          await this.$http.post('/painel/configuracao/restricoes_pontos_venda/salvar', {
            options: this.Options,
            pontos_venda: this.pvsSelecionados,
            nome_funcionalidade: this.NomeFuncionalidade,
            nome_colunas: this.NomeColunas
          })
        } catch (error) {
          notification(AlertTypes.ERROR, `${error.response?.data?.error || error.message}`)
        }
      }
    }
  }
</script>

<style scoped>
    .v-card__text {
        margin-top: 8px;
    }

    .row {
        align-items: center;
    }

    .v-input__control {
        align-items: center;
        justify-items: center;
    }

    .v-input {
        display: flex;
        align-items: center;
    }

    .v-input--selection-controls {
        margin-top: 1.5rem;
    }

    .mt-7 {
        align-self: flex-end;
    }

    .inline-anti-quebra-layout {
        display: inline-flex;
    }

    h3 {
        margin-bottom: 20px;
    }

    .div--comboBox {
        width: 65%;
        overflow: auto;
        max-height: 250px;
    }

    .comboBoxEnorme {
        max-width: 100%;
        margin-bottom: 0px !important;
        max-height: 230px;
        margin: 16px !important;
    }

    .comboBox_container {
        width: 100%;
        max-height: fit-content;
    }

    .comboBox {
        width: 100%;
        overflow: auto;
        margin: 16px;
        margin-left: 0px !important;
        max-height: fit-content;
    }

    .parametros__sistema__h4 {
        margin-top: 15px;
        margin-bottom: 15px;
    }

    .isDisabled {
        overflow: hidden !important;
        border-radius: 10px;
        background-color: #efefef !important;
    }

    @media (max-width: 1360px) {
        .comboBoxEnorme {
            max-width: 40%;
            margin-top: 0px !important;
            margin: 20px !important;
        }
    }

    @media (max-width: 1600px) {
        .comboBoxEnorme {
            max-width: 100%;
            margin-top: 0px !important;
            padding-top: 0;
            max-height: 100%;
            margin: 16px !important;
        }

        .div--comboBox {
            max-width: 55%;
            max-height: 260px;
        }
    }
</style>
